var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "b-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "b-jumbotron",
            [
              _c("template", { slot: "header" }, [
                _c(
                  "p",
                  { staticClass: "text-align-center header-font-style" },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$store.state.report.userEdited.fullname) +
                        "(" +
                        _vm._s(_vm.$store.state.report.userEdited.flag) +
                        ")\n          " +
                        _vm._s(_vm.$store.state.report.userEdited.nricFin) +
                        "\n            "
                    ),
                    !!_vm.$store.state.authUser &&
                    _vm.$store.state.authUser.flag == "Admin"
                      ? _c(
                          "b-button",
                          {
                            attrs: { variant: "danger" },
                            on: {
                              click: function($event) {
                                _vm.popRemoveModal($event.target)
                              }
                            }
                          },
                          [_vm._v("\n              Remove User\n            ")]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _c(
                "b-card",
                { attrs: { "border-variant": "dark", "bg-variant": "light" } },
                [
                  _c(
                    "b-row",
                    { staticClass: "user-edited-panel" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-align-right", attrs: { sm: "3" } },
                        [_vm._v("User Name: ")]
                      ),
                      _c(
                        "b-col",
                        { attrs: { sm: "9" } },
                        [
                          _c("b-form-input", {
                            model: {
                              value: _vm.userEdited.username,
                              callback: function($$v) {
                                _vm.$set(_vm.userEdited, "username", $$v)
                              },
                              expression: "userEdited.username"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    { staticClass: "user-edited-panel" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-align-right", attrs: { sm: "3" } },
                        [_vm._v("Password: ")]
                      ),
                      _c(
                        "b-col",
                        { attrs: { sm: "9" } },
                        [
                          _c("b-form-input", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.userEdited.password,
                              callback: function($$v) {
                                _vm.$set(_vm.userEdited, "password", $$v)
                              },
                              expression: "userEdited.password"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    { staticClass: "user-edited-panel" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-align-right", attrs: { sm: "3" } },
                        [_vm._v("Identity Type: ")]
                      ),
                      _c(
                        "b-col",
                        { attrs: { sm: "9" } },
                        [
                          _c("b-form-select", {
                            attrs: { options: _vm.idType },
                            model: {
                              value: _vm.userEdited.idType,
                              callback: function($$v) {
                                _vm.$set(_vm.userEdited, "idType", $$v)
                              },
                              expression: "userEdited.idType"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    { staticClass: "user-edited-panel" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-align-right", attrs: { sm: "3" } },
                        [_vm._v("Nric / Fin: ")]
                      ),
                      _c(
                        "b-col",
                        { attrs: { sm: "9" } },
                        [
                          _c("b-form-input", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.userEdited.nricFin,
                              callback: function($$v) {
                                _vm.$set(_vm.userEdited, "nricFin", $$v)
                              },
                              expression: "userEdited.nricFin"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    { staticClass: "user-edited-panel" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-align-right", attrs: { sm: "3" } },
                        [_vm._v("D.O.B: ")]
                      ),
                      _c(
                        "b-col",
                        { attrs: { sm: "9" } },
                        [
                          _c("b-form-input", {
                            attrs: { type: "date" },
                            model: {
                              value: _vm.userEdited.dateOfBirth,
                              callback: function($$v) {
                                _vm.$set(_vm.userEdited, "dateOfBirth", $$v)
                              },
                              expression: "userEdited.dateOfBirth"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    { staticClass: "user-edited-panel" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-align-right", attrs: { sm: "3" } },
                        [_vm._v("Name: ")]
                      ),
                      _c(
                        "b-col",
                        { attrs: { sm: "9" } },
                        [
                          _c("b-form-input", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.userEdited.fullname,
                              callback: function($$v) {
                                _vm.$set(_vm.userEdited, "fullname", $$v)
                              },
                              expression: "userEdited.fullname"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    { staticClass: "user-edited-panel" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-align-right", attrs: { sm: "3" } },
                        [_vm._v("Company: ")]
                      ),
                      _c(
                        "b-col",
                        { attrs: { sm: "9" } },
                        [
                          _c("b-form-input", {
                            model: {
                              value: _vm.userEdited.companyName,
                              callback: function($$v) {
                                _vm.$set(_vm.userEdited, "companyName", $$v)
                              },
                              expression: "userEdited.companyName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.$store.state.authUser.flag == "Admin"
                    ? _c(
                        "b-row",
                        { staticClass: "user-edited-panel" },
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "text-align-right",
                              attrs: { sm: "3" }
                            },
                            [_vm._v("Role: ")]
                          ),
                          _c(
                            "b-col",
                            { attrs: { sm: "9" } },
                            [
                              _c("b-form-select", {
                                attrs: { options: _vm.flagType },
                                model: {
                                  value: _vm.userEdited.flag,
                                  callback: function($$v) {
                                    _vm.$set(_vm.userEdited, "flag", $$v)
                                  },
                                  expression: "userEdited.flag"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "b-row",
                    { staticClass: "user-edited-panel" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-align-right", attrs: { sm: "3" } },
                        [_vm._v("Contractor Email: ")]
                      ),
                      _c(
                        "b-col",
                        { attrs: { sm: "9" } },
                        [
                          _c("b-form-input", {
                            model: {
                              value: _vm.userEdited.conEmail,
                              callback: function($$v) {
                                _vm.$set(_vm.userEdited, "conEmail", $$v)
                              },
                              expression: "userEdited.conEmail"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    { staticClass: "user-edited-panel" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-align-right", attrs: { sm: "3" } },
                        [_vm._v("Trades: ")]
                      ),
                      _c(
                        "b-col",
                        { attrs: { sm: "9" } },
                        [
                          _c("b-form-input", {
                            model: {
                              value: _vm.userEdited.trades,
                              callback: function($$v) {
                                _vm.$set(_vm.userEdited, "trades", $$v)
                              },
                              expression: "userEdited.trades"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    { staticClass: "user-edited-panel" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-align-right", attrs: { sm: "3" } },
                        [_vm._v("Check Files: ")]
                      ),
                      _c(
                        "b-col",
                        { attrs: { sm: "9" } },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { block: "", variant: "outline-info" },
                              on: {
                                click: function($event) {
                                  _vm.popCheckFilesModal($event.target)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                show files list and upload panel\n              "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("br"),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-align-right" },
                        [
                          _c(
                            "b-btn",
                            {
                              attrs: {
                                block: "",
                                variant: "success",
                                size: "lg"
                              },
                              on: {
                                click: function($event) {
                                  _vm.editUserInfo()
                                }
                              }
                            },
                            [_vm._v("Update User Information")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("br"),
                  _c("br"),
                  _c(
                    "b-card",
                    {
                      staticClass: "working-profile-container",
                      attrs: {
                        header: "Working Profile",
                        "border-variant": "primary",
                        "header-bg-variant": "primary",
                        "header-text-variant": "white"
                      }
                    },
                    [
                      !!_vm.userEdited.workingProfile &&
                      !!_vm.$store.state.authUser
                        ? _c(
                            "div",
                            [
                              _vm._l(_vm.userEdited.workingProfile, function(
                                value,
                                name
                              ) {
                                return _c(
                                  "b-row",
                                  { staticClass: "user-edited-panel" },
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "text-align-right",
                                        attrs: { sm: "5" }
                                      },
                                      [_vm._v("> " + _vm._s(name) + ": ")]
                                    ),
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "7" } },
                                      [
                                        _c(
                                          "no-ssr",
                                          [
                                            _c("vue-ctk-date-time-picker", {
                                              attrs: {
                                                formatted: "DD-MM-YYYY",
                                                label: "Choose date",
                                                color: "#184167",
                                                "enable-button-validate": "",
                                                "disable-time": ""
                                              },
                                              model: {
                                                value:
                                                  _vm.userEdited.workingProfile[
                                                    name
                                                  ],
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.userEdited
                                                      .workingProfile,
                                                    name,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "userEdited.workingProfile[name]"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              }),
                              _c("br"),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { staticClass: "text-align-right" },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            block: "",
                                            variant: "success",
                                            size: "lg"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.editWorkingProfile()
                                            }
                                          }
                                        },
                                        [_vm._v("Update Working Profile")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c("br")
                            ],
                            2
                          )
                        : _vm._e()
                    ]
                  ),
                  _c("br"),
                  _c(
                    "b-card",
                    {
                      attrs: {
                        "border-variant": "dark",
                        header: "Booked Module Sessions",
                        "header-bg-variant": "info",
                        "header-text-variant": "white"
                      }
                    },
                    [
                      !!_vm.userEditedBookedModuleSession
                        ? _c(
                            "div",
                            { attrs: { role: "tablist" } },
                            _vm._l(_vm.userEditedBookedModuleSession, function(
                              item,
                              index
                            ) {
                              return _c(
                                "b-card",
                                {
                                  key: "bookedModule" + index,
                                  staticClass: "mb-1",
                                  attrs: { "no-body": "" }
                                },
                                [
                                  _c(
                                    "b-card-header",
                                    [
                                      _vm.$store.state.authUser.flag !==
                                        "Admin" &&
                                      Number(item.sessionTime) -
                                        Number(_vm.$moment().format("X")) <=
                                        3600 * 24 * 3
                                        ? _c(
                                            "b-btn",
                                            {
                                              attrs: {
                                                block: "",
                                                disabled: "",
                                                variant: "outline-info"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.expandAccordion(item.id)
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(item.moduleName) +
                                                  " | " +
                                                  _vm._s(
                                                    _vm
                                                      .$moment(
                                                        item.sessionTimeRaw,
                                                        [
                                                          "DD/MM/YYYY HH:mm",
                                                          "DD-MM-YYYY HH:mm",
                                                          _vm.$moment.ISO_8601
                                                        ]
                                                      )
                                                      .format(
                                                        "DD-MM-YYYY HH:mm"
                                                      )
                                                  ) +
                                                  " | " +
                                                  _vm._s(item.language) +
                                                  " | Room:" +
                                                  _vm._s(item.roomId) +
                                                  "\n                  "
                                              )
                                            ]
                                          )
                                        : _c(
                                            "b-btn",
                                            {
                                              attrs: {
                                                block: "",
                                                variant: "outline-info"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.expandAccordion(item.id)
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(item.moduleName) +
                                                  " | " +
                                                  _vm._s(
                                                    _vm
                                                      .$moment(
                                                        item.sessionTimeRaw,
                                                        [
                                                          "DD/MM/YYYY HH:mm",
                                                          "DD-MM-YYYY HH:mm",
                                                          _vm.$moment.ISO_8601
                                                        ]
                                                      )
                                                      .format(
                                                        "DD-MM-YYYY HH:mm"
                                                      )
                                                  ) +
                                                  " | " +
                                                  _vm._s(item.language) +
                                                  " | Room:" +
                                                  _vm._s(item.roomId) +
                                                  "\n                  "
                                              )
                                            ]
                                          )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-collapse",
                                    {
                                      attrs: {
                                        id: item.id,
                                        accordion: "user-edited-accordion",
                                        role: "tab-panel"
                                      }
                                    },
                                    [
                                      _c("b-card-body", [
                                        _vm._v(
                                          "\n                    Module Name: " +
                                            _vm._s(item.moduleName) +
                                            " "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "\n                    Session Time: " +
                                            _vm._s(
                                              _vm
                                                .$moment(item.sessionTimeRaw, [
                                                  "DD/MM/YYYY HH:mm",
                                                  "DD-MM-YYYY HH:mm",
                                                  _vm.$moment.ISO_8601
                                                ])
                                                .format("DD-MM-YYYY HH:mm")
                                            ) +
                                            " "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "\n                    Language: " +
                                            _vm._s(item.language) +
                                            " "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "\n                    Room: " +
                                            _vm._s(item.roomId) +
                                            "\n                    "
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            })
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            ],
            2
          )
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "remove-user" + _vm.userEdited.nricFin,
          attrs: {
            id: "removeCurrentUserModal",
            "hide-footer": "",
            size: "lg",
            title: _vm.removingModalTitle
          }
        },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c("b-form-input", {
                attrs: { placeholder: "enter user nric/fin to confirm" },
                model: {
                  value: _vm.removingNricFin,
                  callback: function($$v) {
                    _vm.removingNricFin = $$v
                  },
                  expression: "removingNricFin"
                }
              }),
              _c(
                "b-btn",
                {
                  staticClass: "mt-3",
                  attrs: { size: "lg", variant: "outline-danger", block: "" },
                  on: {
                    click: function($event) {
                      _vm.removeUser()
                    }
                  }
                },
                [_vm._v("\n          confirm remove user\n        ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "checkFile" + _vm.userEdited.nricFin,
          attrs: {
            id: "checkFilePanel",
            "hide-footer": "",
            size: "lg",
            title: "Check Files"
          }
        },
        [
          _c("h3", [_vm._v("File List")]),
          _vm.userEditedFiles.length
            ? _c(
                "div",
                _vm._l(_vm.userEditedFiles, function(item) {
                  return _c("p", [
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "https://bio-reactorsexyte.sytes.net/uploads/trainingFileUpload/internalTrainingFiles/" +
                            _vm.userEdited.nricFin +
                            "/" +
                            item,
                          target: "_blank"
                        }
                      },
                      [_vm._v(_vm._s(item))]
                    )
                  ])
                })
              )
            : _c("div", [
                _c("p", [_c("i", [_vm._v("No files uploaded yet")])])
              ]),
          _c("div", [_c("UploadFilePanel")], 1)
        ]
      ),
      _c("p", [_vm._v("edit user page")])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e113ded", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e113ded","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/dashboard/management/_userId.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4e113ded","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/dashboard/management/_userId.vue
// module chunks = 12